import { render, staticRenderFns } from "./CostSubcontractPaymentsConfigTable.vue?vue&type=template&id=413f20e1&scoped=true&"
import script from "./CostSubcontractPaymentsConfigTable.vue?vue&type=script&lang=js&"
export * from "./CostSubcontractPaymentsConfigTable.vue?vue&type=script&lang=js&"
import style0 from "./CostSubcontractPaymentsConfigTable.vue?vue&type=style&index=0&id=413f20e1&prod&scoped=true&lang=css&"
import style1 from "./CostSubcontractPaymentsConfigTable.vue?vue&type=style&index=1&id=413f20e1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413f20e1",
  null
  
)

export default component.exports